export {default as style} from './Projects.module.scss'
export {default as styleCard} from './ProjectCard.module.scss'